/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Payment_Terms_Interest_FreeInputs */

const en_clients_payment_terms_interest_free = /** @type {(inputs: Clients_Payment_Terms_Interest_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interest-free installments`)
};

const pt_br2_clients_payment_terms_interest_free = /** @type {(inputs: Clients_Payment_Terms_Interest_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcelamento sem juros`)
};

/**
* | output |
* | --- |
* | "Interest-free installments" |
*
* @param {Clients_Payment_Terms_Interest_FreeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_payment_terms_interest_free = /** @type {((inputs?: Clients_Payment_Terms_Interest_FreeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Payment_Terms_Interest_FreeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_payment_terms_interest_free(inputs)
	return pt_br2_clients_payment_terms_interest_free(inputs)
});